/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateUnitCostRequest } from '../../models/create-unit-cost-request';
import { UnitCostDto } from '../../models/unit-cost-dto';

export interface CreateUnitCost$Params {
      body: CreateUnitCostRequest
}

export function createUnitCost(http: HttpClient, rootUrl: string, params: CreateUnitCost$Params, context?: HttpContext): Observable<StrictHttpResponse<UnitCostDto>> {
  const rb = new RequestBuilder(rootUrl, createUnitCost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UnitCostDto>;
    })
  );
}

createUnitCost.PATH = '/v0/unitCosts/{id}';
